import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetPlatforms } from 'domains/Platform/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../ApplicationFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const PlatformFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [platforms] = useGetPlatforms()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'platform',
    operand: '=='
  })

  return (
    <StyledDetails
      open={localStorage.getItem(`platform-details-visibility`) === 'opened'}>
      <summary
        style={summaryStyles}
        onClick={() => onToggleDetails('platform')}>
        {t('Platform')}
      </summary>
      {platforms?.map((platform, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(platform)}
            onChange={() => onChange(platform)}>
            <Text wordBreak="break-all">
              {platform?.name || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

PlatformFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default PlatformFilter
